import React from 'react';
import { Database, RefreshCw, Plus, Upload } from 'lucide-react';

interface BackupBannerHeaderProps {
  isCreating: boolean;
  onCreateBackup: () => void;
  onFileUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const BackupBannerHeader: React.FC<BackupBannerHeaderProps> = ({
  isCreating,
  onCreateBackup,
  onFileUpload,
}) => {
  return (
    <div className="bg-gradient-to-r from-slate-900 via-indigo-950 to-slate-900 text-white rounded-2xl p-6 sm:p-8 shadow-xl relative overflow-hidden">
      <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="space-y-2 max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/20 border border-indigo-400/30 text-indigo-300 text-xs font-semibold">
            <Database className="w-3.5 h-3.5 text-indigo-400" />
            <span>Manajemen Pangkalan Data SQLite UIBN</span>
          </div>
          <h2 className="text-xl sm:text-2xl font-extrabold tracking-tight text-white">
            Backup & Restore Database
          </h2>
          <p className="text-xs sm:text-sm text-slate-300 leading-relaxed">
            Buat cadangan data (*export dump*) instan, unduh snapshot SQLite/JSON, dan pulihkan (*restore*) pangkalan data nasional secara cepat dan aman.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={onCreateBackup}
            disabled={isCreating}
            className="px-4 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs sm:text-sm shadow-lg shadow-indigo-600/30 flex items-center justify-center gap-2 transition cursor-pointer disabled:opacity-50"
          >
            {isCreating ? (
              <RefreshCw className="w-4 h-4 animate-spin" />
            ) : (
              <Plus className="w-4 h-4" />
            )}
            <span>Buat Backup Instan</span>
          </button>

          <label className="px-4 py-2.5 rounded-xl bg-slate-800 hover:bg-slate-700 text-slate-200 border border-slate-700 font-bold text-xs sm:text-sm flex items-center justify-center gap-2 transition cursor-pointer shadow-sm">
            <Upload className="w-4 h-4 text-indigo-400" />
            <span>Upload Backup (.json)</span>
            <input
              type="file"
              accept=".json"
              onChange={onFileUpload}
              className="hidden"
            />
          </label>
        </div>
      </div>
    </div>
  );
};
